// Angular
import { inject, PLATFORM_ID } from '@angular/core';
import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
// RxJs
import { Observable } from 'rxjs';
// Constants
import { APP_CONSTANT } from '@constants';
// Service
import { CommonService } from './common.service';

export const TokenInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<any>> => {
  // Inject
  const cs = inject(CommonService);

  let headers: Record<string, string> = {};

  // Add JWT
  const jwt = cs.getFromLocalStorage(APP_CONSTANT.JWT_TOKEN_KEY);
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`;
  }

  // Add timezone
  headers['x-timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const modifiedRequest = req.clone({
    setHeaders: headers
  });

  return next(modifiedRequest);
};